import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.regexp.search";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { addproject, putproject } from '@/api/deviceOverview/file';
export default {
  name: 'fileModal',
  props: {
    DialogVisible: {
      type: Boolean,
      default: false
    },
    dialogType: {
      type: String
    }
  },
  data: function data() {
    return {
      rules: {
        projectName: [{
          required: true,
          message: this.$t('userManage.pleInputProName'),
          trigger: 'blur'
        }],
        province: [{
          required: true,
          message: this.$t('fileManage.inputProvinceName'),
          trigger: 'blur'
        }],
        city: [{
          required: true,
          message: this.$t('fileManage.inputCityName'),
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: this.$t('fileManage.inputLatitude'),
          trigger: 'change'
        }, {
          pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
          message: this.$t('userManage.phoneFault')
        }] // lat:[
        //      { required: true, message: '请输入经度', trigger: 'change' }
        // ],

      },
      form: {
        location: {
          lat: null,
          lon: null
        },
        status: ''
      },
      pointChoseType: 'chose',
      formLabelWidth: '190px',
      keyWordObj: null,
      // 关键词检索变量
      map: null,
      disabled: false,
      mapsearch: '',
      disabledLocation: '',
      typeList: [{
        name: this.$t('fileManage.set'),
        value: '0'
      }, {
        name: this.$t('fileManage.debug'),
        value: '1'
      }]
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: _defineProperty({
    closedialog: function closedialog() {
      this.init();
      this.$emit('closefile');
    },
    mapKeyWord: function mapKeyWord() {},
    getinfo: function getinfo(info) {
      var res = JSON.parse(JSON.stringify(info));

      if (res.location) {
        res.location = JSON.parse(res.location);
      }

      this.form = res;
    },
    // 分页导航
    handleCurrentChange: function handleCurrentChange(val) {
      this.param.current = val;
    },
    // 提交表单
    handleSubmit: function handleSubmit() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        console.log(_this2.form);
        debugger;

        if (valid) {
          _this2.form.location = JSON.stringify(_this2.form.location);

          if (_this2.dialogType === _this2.$t('userManage.newAdd')) {
            addproject(_this2.form).then(function (res) {
              if (res.data.code === 200) {
                _this2.$message.success(res.data.msg);

                _this2.$emit('closefile', '0');

                _this2.init();

                console.log(_this2.form);
              }
            });
          } else {
            putproject(_this2.form).then(function (res) {
              if (res.data.code === 200) {
                _this2.$message.success(res.data.msg);

                _this2.$emit('closefile', '0');

                _this2.init();
              }
            });
          }
        }
      });
    },
    beforeClose: function beforeClose(done) {
      this.$emit('closefile');
      this.init();
    },
    init: function init() {
      this.form = {
        location: {
          lat: null,
          lon: null
        },
        status: ''
      };
      this.$refs.form.resetFields();
    },
    mapinit: function mapinit() {
      // 创建地图实例
      this.map = new BMap.Map('StationMap'); // 设置中心点和缩放比例
      // this.map.centerAndZoom(new BMap.Point(116.404, 39.915), 11)

      this.prePoint = this.form.location;

      if (this.form.location.lon == null || this.form.location.lon == '') {
        this.map.centerAndZoom(this.$t('fileInfo.hangZhou'), 11);
      } else {
        this.map.centerAndZoom(new BMap.Point(this.form.location.lon, this.form.location.lat), 11);
        var point = new BMap.Point(this.form.location.lon, this.form.location.lat);
        var myIcon = new BMap.Icon(require('@/assets/img/map_icon.png'), new BMap.Size(47, 49));
        var marker = new BMap.Marker(point, {
          icon: myIcon
        }); // 创建标注

        this.map.addOverlay(marker); // 将标注添加到地图中
      } // 修改地图主题样式


      this.map.setMapStyle({
        style: this.currentMayStyle
      }); // 开启鼠标滚轮缩放

      this.map.enableScrollWheelZoom(true);
    },
    // 选择-地图上选点
    mapselectpoint: function mapselectpoint() {
      // 修改选点方式
      this.pointChoseType = 'chose'; // 1、地图上选点(chose) 2、关键词搜索(search)
      // 清除地图

      this.map = null; // 清除 地点关键词

      this.form.locationKeyWord = ''; // 地点关键词
      // 设置地图

      this.$nextTick(function () {
        // 百度地图是必须让它在页面加载完成后显示（生命周期mounted），但是由于element的对话框（el-dialog）是基于v-if这个功能。所以，应该在dom加载完后再初始化地图
        // 地图初始化
        this.mapinit(); // 添加点击地图监听事件---点击地图后添加标注点

        this.map.addEventListener('click', function (e) {
          // console.log(e)
          // 清除标注点
          this.map.clearOverlays(); // 添加标注点

          var point = new BMap.Point(e.point.lng, e.point.lat); // 创建点

          var myIconOn = new BMap.Icon(require("@/assets/img/map_icon.png"), new BMap.Size(47, 49));
          var marker = new BMap.Marker(point, {
            icon: myIconOn
          }); // 创建标注
          // var marker = new BMap.Marker(point)  // 创建标注

          this.map.addOverlay(marker); // 将标注添加到地图中
          // 修改form表单内容
          // 设备坐标

          this.form.location = {
            'lat': e.point.lat.toFixed(6),
            'lon': e.point.lng.toFixed(6)
          };
          var geoc = new BMap.Geocoder(); // 用于获取用户的地址解析
          // 地址解析

          geoc.getLocation(e.point, function (rs) {
            var addComp = rs.addressComponents; // 设备所在省份

            this.form.province = addComp.province; // 设备所在城市

            this.form.city = addComp.city;
            this.$forceUpdate();
          }.bind(this));
        }.bind(this));
      }.bind(this));
    },
    // 选择-关键词搜索
    mapkeyword: function mapkeyword() {
      console.log(1); // 修改选点方式
      // debugger

      this.pointChoseType = 'search'; // 1、地图上选点(chose) 2、关键词搜索(search)
      // 清除地图

      this.map = null; // 清除 地点关键词

      this.form.locationKeyWord = ''; // 地点关键词
      // 设置地图

      this.$nextTick(function () {
        // 百度地图是必须让它在页面加载完成后显示（生命周期mounted），但是由于element的对话框（el-dialog）是基于v-if这个功能。所以，应该在dom加载完后再初始化地图
        // 地图初始化
        this.mapinit();

        var _this = this; // 关键词检索


        var gjcOptions = {
          // 结果呈现设置
          renderOptions: {
            map: this.map
          },
          // // 标注添加完成后的回调函数
          // onMarkersSet: function () {
          //   console.log('onMarkersSet')
          // },
          // 标注气泡内容创建后的回调函数---点击不同气泡会触发
          onInfoHtmlSet: function onInfoHtmlSet(res) {
            // 修改form表单内容
            // 设备坐标
            _this.form.location = {
              'lat': res.point.lat.toFixed(6),
              'lon': res.point.lng.toFixed(6)
            }; // 设备所在省份

            _this.form.province = res.province; // 设备所在城市

            _this.form.city = res.city;
          } // // 结果列表添加完成后的回调函数
          // onResultsHtmlSet: function () {
          //   console.log('onResultsHtmlSet')
          // },
          // // 检索完成后的回调函数
          // onSearchComplete: function (results) {
          //   console.log(results)
          // }

        }; // console.log(gjcOptions)

        this.keyWordObj = new BMap.LocalSearch(this.map, gjcOptions); // 用于位置检索、周边检索和范围检索。

        var allOverlay = this.map.getOverlays();
        console.log(allOverlay); // this.keyWordObj.search("景点")
        // 添加点击地图监听事件---点击地图后添加标注点

        this.map.addEventListener('click', function (e) {
          // console.log(e)
          // console.log(this.prePoint)
          // 清除标注点
          // this.map.clearOverlays(marker)
          var allOverlay = this.map.getOverlays(); // console.log(allOverlay)
          // console.log(this.prePoint)

          for (var i = 0; i < allOverlay.length; i++) {
            if (allOverlay[i].point && allOverlay[i].point.lng == this.prePoint.lon && allOverlay[i].point.lat == this.prePoint.lat) {
              this.map.removeOverlay(allOverlay[i]); // return false;
            }
          }

          this.mapsearch = ''; // 添加标注点

          var point = new BMap.Point(e.point.lng, e.point.lat); // 创建点

          var myIconOn = new BMap.Icon(require("@/assets/img/map_icon.png"), new BMap.Size(47, 49));
          var marker = new BMap.Marker(point, {
            icon: myIconOn
          }); // 创建标注
          // var marker = new BMap.Marker(point)  // 创建标注

          this.map.addOverlay(marker); // 将标注添加到地图中
          // 修改form表单内容
          // 设备坐标

          this.form.location = {
            'lat': e.point.lat.toFixed(6),
            'lon': e.point.lng.toFixed(6)
          };
          this.prePoint = {
            'lat': e.point.lat,
            'lon': e.point.lng
          };
          var geoc = new BMap.Geocoder(); // 用于获取用户的地址解析
          // 地址解析

          geoc.getLocation(e.point, function (rs) {
            var addComp = rs.addressComponents; // 设备所在省份

            this.form.province = addComp.province; // 设备所在城市

            this.form.city = addComp.city;
          }.bind(this));
        }.bind(this));
      }.bind(this));
    }
  }, "mapKeyWord", function mapKeyWord() {
    console.log(2);
    this.keyWordObj.search(this.mapsearch);
  })
};